import { get, post, put, del } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class CategoryService {

    static async getAll(page, size, filters = {}, sortConfig = {}) {
        const companyId = getCompanyId();
        const queryParams = buildCrudQueryParams({
            page,
            size,
            filters,
            sortConfig,
            companyId,
            sortMode: 'split',
        });

        return await get(`/category?${queryParams.toString()}`);
    }

    static async createCategory(newCategory) {
        const companyId = getCompanyId();
        const categoryData = {
            ...newCategory,
            companyId: companyId
        };
        return await post('/category', categoryData);
    }

    static async updateCategory(categoryId, updatedCategory) {
        const companyId = getCompanyId();
        const categoryData = {
            ...updatedCategory,
            companyId: companyId
        };
        return await put(`/category/${categoryId}`, categoryData);
    }

    static async deleteCategory(categoryId) {
        return await del(`/category/${categoryId}`);
    }

    static async updateEnabled(categoryId, updatedCategory) {
        const companyId = getCompanyId();
        const categoryData = {
            ...updatedCategory,
            companyId: companyId
        };
        return await put(`/category/enabled/${categoryId}`, categoryData);
    }

    // Alias para compatibilidad con CrudManager
    static async create(newCategory) {
        return this.createCategory(newCategory);
    }

    static async update(categoryId, updatedCategory) {
        return this.updateCategory(categoryId, updatedCategory);
    }

    static async delete(categoryId) {
        return this.deleteCategory(categoryId);
    }
}

export default CategoryService;
